import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import cn from 'classnames';
import pt from 'prop-types';
import useSWR from 'swr';
import { debounce } from 'lodash';
import {
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  LinearProgress as MuiLinearProgress,
  withStyles,
  Fade,
} from '@material-ui/core';
import { AxiosCancelToken, dataFetcher } from 'Api';
import { AppContext } from 'Context';
import { ReactComponent as AddPersonIcon } from 'Assets/add-person.svg';
import { ReactComponent as LinkIcon } from 'Assets/link.svg';
import AlterImage from 'Assets/alter-image.png';

import { Snackbar } from '../snackbar/index';
import { Button } from '../button';
import styles from './index.module.css';
import SearchInput from './components/SearchInput';
import NewSearchInput from './components/NewSearchInput';
import PersonButton from './components/PersonButton';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
} from './components/CustomDesigns';

export const ShareScreen = ({
  toastForGroup,
  actionButtonLoadingText,
  actionButtonText,
  apiEndpoint,
  errorText,
  hasLink,
  hideContent,
  imageEditable,
  inputPlaceholder,
  isVisible,
  linkDescription,
  linkTitle,
  multipleSelect,
  notes,
  noUsersFoundText,
  onContinue,
  onHide: closeHandler,
  requireTitle,
  successText,
  title,
  titleEditable,
  titlePlaceholder,
  tempGroupTitle,
  oldGroupMember,
  oldMembersData,
  grandAccess,
  subTitle,
}) => {
  const defaultSnackbar = {
    isVisible: false,
    type: undefined,
    message: undefined,
  };
  const { setAppSnackbar, userDetails } = useContext(AppContext);
  console.log('Current user email:', userDetails?.email);
  const [snackbar, setSnackbar] = useState(defaultSnackbar);
  const [titleName, setTitleName] = useState('');
  const [imageBase64, setImageBase64] = useState('');
  const [emailToSearch, setEmailToSearch] = useState('');
  const [searchingUsers, setUserSearchingStatus] = useState(false);
  const [cancelToken, setCancelToken] = useState(undefined);
  const [selectedUsers, updateSelectedUsers] = useState([]);
  const [operationStatus, setOperationStatus] = useState(undefined);
  const [userList, setUserList] = useState([]);
  // useEffect(() => {
  //   let oldMembers = [];
  //   oldMembers = oldGroupMember || [];
  //   updateSelectedUsers([...oldMembers]);
  // }, [oldGroupMember]);
  // console.log('oldmembers', oldGroupMember);

  const [handlingAction, setActionHandlingStatus] = useState(false);
  const [duplicateErrorType, setDuplicateErrorType] = useState(null); // 'member', 'pending', or null
  const [isSelfSelected, setIsSelfSelected] = useState(false);
  const emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  const location = useLocation();
  const onHide = () => {
    setOperationStatus(undefined);
    if (!handlingAction) {
      setEmailToSearch('');
      setImageBase64('');
      updateSelectedUsers([]);
      setUserSearchingStatus(false);
      setUserList([]);
      setDuplicateErrorType(null);
      setIsSelfSelected(false);
      if (closeHandler) {
        closeHandler();
      }
    }
  };
  const selectUser = (userData) => {
    updateSelectedUsers(
      multipleSelect ? [...selectedUsers, userData] : [userData]
    );
  };
  const removeUser = (userData) => {
    updateSelectedUsers(
      selectedUsers.filter(
        (selectedUserData) => selectedUserData.id !== userData.id
      )
    );
  };

  const { mutate: searchUsersByEmail } = useSWR(
    [apiEndpoint, emailToSearch, cancelToken?.token],
    {
      fetcher: (url, inputEmail, uniqueCancelToken) => dataFetcher(url, { email: inputEmail }, uniqueCancelToken),
      onSuccess: ({ success, data, message }) => {
        // eslint-disable-next-line no-console
        console.log('🔍 Search API Response:', { success, dataLength: data?.length, message, emailToSearch });
        setUserSearchingStatus(false);
        if (success) {
          if (emailToSearch !== '') {
            const ids = selectedUsers?.map((user) => user.id);
            const newData = data?.filter((item) => !ids.includes(item.id));
            // eslint-disable-next-line no-console
            console.log('📊 Filtered data:', { originalLength: data?.length, filteredLength: newData?.length });

            // Data found, filter and set user list
            if (newData && newData.length > 0) {
              // eslint-disable-next-line no-console
              console.log('✅ Showing real user data');

              setUserList(
                newData
                  ?.filter(
                    (userData) => userData.status === null
                      || userData.status === undefined
                  )
                  ?.slice(0, 5)
              );
            } else if (
              // No matching users found - only show fallback email for groups/successors
              // ONLY when API explicitly says no user found (not just empty data)
              (message === 'No Matching user found' || message === 'User Not Exist')
              && (location.pathname === '/viewers/groups' || grandAccess)
              && emailRegEx.test(emailToSearch)
            ) {
              // eslint-disable-next-line no-console
              console.log('⚠️ Showing fallback (typed email only) - No user found in system');
              const list = {
                email: emailToSearch,
                id: emailToSearch,
                status: null,
                firstname: '',
                lastname: '',
              };
              setUserList([list]);
            } else {
              // If no data or empty after filtering, just show empty list
              // eslint-disable-next-line no-console
              console.log('❌ No data to show - clearing list');
              setUserList([]);
            }
          }
        } else if (emailToSearch && emailRegEx.test(emailToSearch)) {
          // API call failed, but still append email if valid for groups
          if (location.pathname === '/viewers/groups' || grandAccess) {
            const list = {
              email: emailToSearch,
              id: emailToSearch,
              status: null,
              firstname: '',
              lastname: '',
            };
            setUserList([list]);
          } else {
            setUserList([]);
          }
        } else {
          setUserList([]);
        }
        //       setAppSnackbar({
        //         isVisible: !data?.[0] || data[0]?.status !== null,
        //           duration: 1500,
        // message: !data?.[0] ? 'No Matching user'
        //           : data[0]?.status === '0'
        //             ? 'Already requested this projector - Awaiting response'
        //             : data[0]?.status === '1' && 'You are already a viewer',
        //       });
      },
      onError: () => {
        setUserSearchingStatus(false);
        setUserList([]);
      },
      // Disable caching to always fetch fresh data
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 0, // Disable deduplication to ensure fresh fetches
      revalidateIfStale: true, // Always refetch if data is stale
    }
  );

  const searchInputHandler = debounce(
    ({ target: { value: inputEmail } }) => {
      if (inputEmail) {
        setEmailToSearch(inputEmail);
      } else {
        setEmailToSearch('');
        setUserList(undefined);
      }
    },
    750,
    { trailing: true }
  );

  const searchUsers = ({ target: { value: inputEmail } }) => {
    if (
      inputEmail
      && (location.pathname.includes('/successors')
        || location.pathname.includes('/groups')
        || location?.search?.includes('create-group'))
    ) {
      setEmailToSearch(inputEmail);
    } else if (inputEmail && emailRegEx.test(inputEmail)) {
      setEmailToSearch(inputEmail);
    } else {
      setEmailToSearch('');
      setUserList([]);
    }
  };
  const removeUserFromList = (selectedUser) => {
    // eslint-disable-next-line no-console
    console.log('❌ Removing user from selection (Cross icon clicked):', {
      removedUser: selectedUser,
      currentSelectedUsers: selectedUsers,
    });
    const newSelectedUsers = selectedUsers.filter(
      (selectedUserData) => selectedUserData.id !== selectedUser.id
    );
    // eslint-disable-next-line no-console
    console.log('📋 Updated selected users after removal:', newSelectedUsers);
    updateSelectedUsers(newSelectedUsers);

    // Re-check if user still has themselves selected after removal
    const currentUserEmail = userDetails?.email?.toLowerCase();
    const isSelf = newSelectedUsers.some((user) => user.email?.toLowerCase() === currentUserEmail);
    setIsSelfSelected(isSelf);

    // Re-check for duplicates after removal (only if not self-selected)
    if (!isSelf && oldMembersData) {
      const members = oldMembersData.members || [];
      const pendingMembers = oldMembersData.pendingMembers || [];

      const hasMemberDuplicate = newSelectedUsers.some((user) => members.some((member) => member.email === user.email || member.id === user.id));
      const hasPendingDuplicate = newSelectedUsers.some((user) => pendingMembers.some((member) => member.email === user.email || member.id === user.id));

      if (hasMemberDuplicate) {
        setDuplicateErrorType('member');
      } else if (hasPendingDuplicate) {
        setDuplicateErrorType('pending');
      } else {
        setDuplicateErrorType(null);
      }
    } else {
      setDuplicateErrorType(null);
    }
  };

  const selectUserFromList = (selectedUser) => {
    const newSelectedUsers = multipleSelect ? [...selectedUsers, selectedUser] : [selectedUser];
    updateSelectedUsers(newSelectedUsers);

    // Check if user is trying to add themselves
    const currentUserEmail = userDetails?.email?.toLowerCase();
    const isSelf = newSelectedUsers.some((user) => user.email?.toLowerCase() === currentUserEmail);
    setIsSelfSelected(isSelf);

    // Check if any newly selected user is a duplicate (only if not self-selected)
    if (!isSelf && oldMembersData) {
      const members = oldMembersData.members || [];
      const pendingMembers = oldMembersData.pendingMembers || [];

      const hasMemberDuplicate = newSelectedUsers.some((user) => members.some((member) => member.email === user.email || member.id === user.id));
      const hasPendingDuplicate = newSelectedUsers.some((user) => pendingMembers.some((member) => member.email === user.email || member.id === user.id));

      if (hasMemberDuplicate) {
        setDuplicateErrorType('member');
      } else if (hasPendingDuplicate) {
        setDuplicateErrorType('pending');
      } else {
        setDuplicateErrorType(null);
      }
    } else if (isSelf) {
      setDuplicateErrorType(null);
    }
  };
  // Debounce API calls - only call after user stops typing for 500ms
  useEffect(() => {
    const emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    // Don't show any suggestions while user is typing
    if (emailToSearch && emailRegEx.test(emailToSearch)) {
      // Clear suggestions immediately when user types
      setUserList([]);

      // Debounce the API call - wait 500ms after user stops typing
      const debounceTimer = setTimeout(() => {
        // eslint-disable-next-line no-console
        console.log('🚀 Calling API for:', emailToSearch);
        setUserSearchingStatus(true);
        searchUsersByEmail();
      }, 500);

      // Cleanup: cancel the API call if user keeps typing
      return () => {
        clearTimeout(debounceTimer);
      };
    }

    if (!emailToSearch) {
      // Clear suggestions when search is empty
      setUserList([]);
    }
    return undefined;
  }, [emailToSearch, setUserSearchingStatus, searchUsersByEmail]);

  useEffect(() => {
    if (operationStatus === true) {
      setAppSnackbar({ isVisible: true, message: successText });
    } else if (operationStatus === false) {
      setAppSnackbar({ isVisible: true, type: 'error', message: errorText });
    }
  }, [operationStatus, errorText, successText, setAppSnackbar]);

  return (
    <Dialog
      className={styles.shareScreen}
      onClose={onHide}
      open={isVisible}
      TransitionComponent={Fade}
    >
      <DialogTitle className={styles.shareScreenHeading}>
        <div className={styles.shareScreenHeadingContent}>
          {imageEditable ? (
            <>
              {hideContent && (
                <input
                  accept="image/*"
                  className={styles.hiddenFormField}
                  disabled={handlingAction || !hideContent}
                  id="share-screen-image-input"
                  onChange={({ target: { files } }) => {
                    const reader = new FileReader();
                    const file = files[0];
                    if (file) {
                      reader.readAsDataURL(file);
                    }
                    reader.addEventListener(
                      'load',
                      () => {
                        setImageBase64(reader.result);
                      },
                      false
                    );
                  }}
                  type="file"
                />
              )}
              <div className={styles.addPersonIconContainer}>
                {imageBase64 ? (
                  <>
                    <label
                      className={styles.addPersonImageContainer}
                      htmlFor="share-screen-image-input"
                    >
                      <img
                        alt="Group Icon"
                        className={styles.imagePreview}
                        src={imageBase64 || AlterImage}
                        onError={(e) => {
                          e.target.src = AlterImage;
                        }}
                      />
                    </label>
                    {!handlingAction && hideContent && (
                      <button
                        className={styles.imageDeleteButton}
                        onClick={() => {
                          document.getElementById(
                            'share-screen-image-input'
                          ).value = '';
                          setImageBase64(undefined);
                        }}
                      />
                    )}
                  </>
                ) : (
                  <label
                    className={cn({
                      [styles.addPersonImageContainer]: true,
                      [styles.hasBG]: true,
                    })}
                    htmlFor="share-screen-image-input"
                  >
                    <AddPersonIcon className={styles.addPersonIcon} />
                  </label>
                )}
              </div>
            </>
          ) : (
            <div className={styles.addPersonIconContainer}>
              <div
                className={cn({
                  [styles.addPersonImageContainer]: true,
                  [styles.hasBG]: true,
                })}
              >
                <AddPersonIcon className={styles.addPersonIcon} />
              </div>
            </div>
          )}
          {titleEditable ? (
            <input
              className={styles.titleInput}
              disabled={handlingAction || !hideContent}
              onInput={({ target: { value: inputTitle } }) => {
                setTitleName(inputTitle);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  const isDisabled = actionButtonText === 'Create Group'
                    ? requireTitle || !titleName || (!hideContent && selectedUsers?.length <= 0) || handlingAction
                    : (requireTitle && !titleName) || (!hideContent && selectedUsers?.length <= 0) || handlingAction;

                  if (!isDisabled) {
                    // eslint-disable-next-line no-console
                    console.log('👥 Adding users to backend (via Title Enter):', {
                      count: selectedUsers?.length,
                      users: selectedUsers,
                      titleName,
                    });
                    onContinue([
                      onHide,
                      setActionHandlingStatus,
                      setOperationStatus,
                      updateSelectedUsers,
                      setUserList,
                      selectedUsers,
                      titleName,
                      imageBase64,
                    ]);
                  }
                }
              }}
              placeholder={titlePlaceholder}
              maxLength={70}
              type="text"
              autoFocus
            />
          ) : subTitle ? (
            <div>
              <div>{title}</div>
              <div className={styles.subTitle}>{subTitle}</div>
            </div>
          ) : (
            <>{title}</>
          )}
        </div>
        {!hideContent && (
          <NewSearchInput
            handlingAction={handlingAction}
            searchInputHandler={searchInputHandler}
            setUserSearchingStatus={setUserSearchingStatus}
            cancelToken={cancelToken}
            setEmailToSearch={setEmailToSearch}
            setUserList={setUserList}
            setCancelToken={setCancelToken}
            AxiosCancelToken={AxiosCancelToken}
            inputPlaceholder={inputPlaceholder}
            selectedUsers={selectedUsers}
            isDisabled={handlingAction}
            removeUser={removeUser}
            isSelected
            grandAccess
            searchUsers={searchUsers}
            userList={userList}
            searchingUsers={searchingUsers}
            selectUser={selectUser}
            selectUserFromList={selectUserFromList}
            removeUserFromList={removeUserFromList}
            emailToSearch={emailToSearch}
            duplicateErrorType={duplicateErrorType}
            isSelfSelected={isSelfSelected}
            onEnterPress={() => {
              const isDisabled = actionButtonText === 'Create Group'
                ? requireTitle || !titleName || (!hideContent && selectedUsers?.length <= 0) || handlingAction
                : (requireTitle && !titleName) || (!hideContent && selectedUsers?.length <= 0) || handlingAction;

              if (!isDisabled) {
                // eslint-disable-next-line no-console
                console.log('👥 Adding users to backend (via Search Enter):', {
                  count: selectedUsers?.length,
                  users: selectedUsers,
                  titleName,
                });
                onContinue([
                  onHide,
                  setActionHandlingStatus,
                  setOperationStatus,
                  updateSelectedUsers,
                  setUserList,
                  selectedUsers,
                  titleName,
                  imageBase64,
                ]);
              }
            }}
          />
        )}
        {/* {searchingUsers && <LinearProgress className={styles.loader} />} */}
      </DialogTitle>

      {!hideContent && (
        <DialogContent className={styles.shareScreenContent}>
          <br />
        </DialogContent>
      )}
      <DialogActions
        className={styles.shareScreenActions}
        style={{ borderTopLeftRadius: '0', borderTopRightRadius: '0' }}
      >
        <Snackbar
          isVisible={toastForGroup?.message && snackbar?.isVisible}
          message={toastForGroup?.message || '...'}
          onClose={() => {
            setSnackbar(defaultSnackbar);
          }}
          type={snackbar?.type}
        />
        <Button
          className={styles.shareScreenDoneButton}
          isBlue
          isDisabled={
            actionButtonText === 'Create Group'
              ? requireTitle
              || !titleName
              || (!hideContent && selectedUsers?.length <= 0)
              || handlingAction
              : (requireTitle && !titleName)
              || (!hideContent && selectedUsers?.length <= 0)
              || handlingAction
              || duplicateErrorType !== null
              || isSelfSelected
          }
          onClick={() => {
            // eslint-disable-next-line no-console
            console.log('👥 Adding users to backend:', {
              count: selectedUsers?.length,
              users: selectedUsers,
              titleName,
            });
            onContinue([
              onHide,
              setActionHandlingStatus,
              setOperationStatus,
              updateSelectedUsers,
              setUserList,
              selectedUsers,
              titleName,
              imageBase64,
            ]);
          }}
        >
          {handlingAction ? actionButtonLoadingText : actionButtonText}
        </Button>
      </DialogActions>

      {hasLink && (
        <DialogActions
          className={cn({
            [styles.shareScreenActions]: true,
            [styles.linkShare]: true,
          })}
        >
          <div className={styles.shareScreenHeadingContent}>
            <LinkIcon className={styles.linkIcon} />
            <>{linkTitle}</>
          </div>
          <div className={styles.shareScreenLinkText}>{linkDescription}</div>
          <div className={styles.shareScreenLinkButton}>Copy Link</div>
        </DialogActions>
      )}
    </Dialog>
  );
};
